import { ContainerDto, ContainerType, UnitType } from '@planning/app/api'
import { containerService } from '@planning/services'
import { SearchAutocompleteStore } from '@planning/stores/SearchAutocompleteStore'
import { action, makeObservable, observable } from 'mobx'

const fetch = async (
  filter: string,
  isEmpty?: boolean,
  hasServiceOrders?: boolean,
  canAssignServiceOrders?: boolean,
  type?: ContainerType,
  isOnTerminal?: boolean,
  isoCode?: string,
  operator?: string,
  includeRestow?: boolean,
) =>
  await containerService.getContainersByPartialNumber(
    filter,
    isEmpty,
    hasServiceOrders,
    canAssignServiceOrders,
    type,
    isoCode,
    isOnTerminal,
    operator,
    includeRestow,
  )

export class ContainerAutocompleteStore extends SearchAutocompleteStore<ContainerDto> {
  isEmpty?: boolean
  includeRestow?: boolean
  isOnTerminal?: boolean
  isoCode?: string
  operator?: string
  hasServiceOrders?: boolean
  canAssignServiceOrders?: boolean
  type?: ContainerType
  filteredContainerNumbers: string[] = []
  selectedUnitTypeFilter?: UnitType

  constructor() {
    super(
      (query: string) =>
        fetch(
          query,
          this.isEmpty,
          this.hasServiceOrders,
          this.canAssignServiceOrders,
          this.type,
          this.isOnTerminal,
          this.isoCode,
          this.operator,
          this.includeRestow,
        ),
      container =>
        !!container.id &&
        (!this.selectedUnitTypeFilter || container.unitType === this.selectedUnitTypeFilter) &&
        !this.filteredContainerNumbers.includes(container.number ?? ''),
    )
    makeObservable(this, {
      isEmpty: observable,
      includeRestow: observable,
      isOnTerminal: observable,
      isoCode: observable,
      operator: observable,
      hasServiceOrders: observable,
      canAssignServiceOrders: observable,
      type: observable,
      filteredContainerNumbers: observable,
      selectedUnitTypeFilter: observable,
      setIsEmpty: action,
      setIncludeRestow: action,
      setHasServiceOrders: action,
      setCanAssignServiceOrders: action,
      setType: action,
      setIsoCode: action,
      setIsOnTerminal: action,
      setOperator: action,
      setFilteredContainerNumbers: action,
      reset: action,
    })
  }
  setSelectedUnitTypeFilter = (type: UnitType) => (this.selectedUnitTypeFilter = type)
  setType = (type?: ContainerType) => (this.type = type)
  setIsEmpty = (isEmpty?: boolean) => (this.isEmpty = isEmpty)
  setIncludeRestow = (includeRestow?: boolean) => (this.includeRestow = includeRestow)

  setHasServiceOrders = (hasServiceOrders?: boolean) => (this.hasServiceOrders = hasServiceOrders)
  setCanAssignServiceOrders = (canAssingServiceOrders?: boolean) =>
    (this.canAssignServiceOrders = canAssingServiceOrders)
  setIsoCode = (isoCode?: string) => (this.isoCode = isoCode)
  setIsOnTerminal = (isOnTerminal?: boolean) => (this.isOnTerminal = isOnTerminal)
  setOperator = (operator?: string) => (this.operator = operator)
  setFilteredContainerNumbers = (filteredContainerNumbers: string[]) =>
    (this.filteredContainerNumbers = filteredContainerNumbers)

  reset = () => {
    this.setFilter('')
    this.setValue()
    this.items = []
    this.setIsEmpty()
    this.setIncludeRestow()
    this.setHasServiceOrders()
    this.setCanAssignServiceOrders()
    this.setType()
    this.setIsoCode()
    this.setIsOnTerminal()
    this.setOperator()
    this.setFilteredContainerNumbers([])
  }
}
